import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import check from "../../assets/icons/mdi_check.svg";
import creaditCartRed from "../../assets/images/tpbank_red.png";
import creaditCartBlue from "../../assets/images/tpbank_blue.png";
import creaditCartPurple from "../../assets/images/tpbank_purple.png";
import star from "../../assets/icons/5-star-ic.svg";
import cardSecure from "../../assets/icons/card-secure.svg";
import contactless from "../../assets/icons/card-NFT-icon.svg";
import visa from "../../assets/icons/visa-icon.svg";
import cardMoneyOnline from "../../assets/icons/Card-Money-Online.svg";
import cardApp from "../../assets/icons/Card-APp-icon.svg";
import cardHandTouch from "../../assets/icons/Card-hand-touch-ic.svg";
import cardGroup from "../../assets/icons/Card-Group.svg";
import {
  getCardById,
  getTrackingLink,
} from "../../services/CardService";
import ExclusiveOffer from "./exclusiveOffer";

const FALLBACK_CARD_IMAGES = [
  creaditCartRed,
  creaditCartBlue,
  creaditCartPurple,
];

const DEFAULT_HEADERS = {
  "Content-Type": "application/json",
};

const formatCurrencyVND = (value) => {
  if (value === undefined || value === null || value === "") {
    return "";
  }

  if (typeof value === "number") {
    try {
      return `${value.toLocaleString("vi-VN")} VNĐ`;
    } catch (error) {
      return `${value} VNĐ`;
    }
  }

  const numericValue = Number(value);
  if (!Number.isNaN(numericValue) && value !== "") {
    try {
      return `${numericValue.toLocaleString("vi-VN")} VNĐ`;
    } catch (error) {
      return `${numericValue} VNĐ`;
    }
  }

  return value;
};

const parseBenefits = (benefits) => {
  if (Array.isArray(benefits)) {
    return benefits.filter(Boolean);
  }
  return [];
};

const convertFuturesCardCode = (code) => {
  const codeMap = {
    PDC: "Tỷ lệ phê duyệt cao",
    CTO: "Chi tiêu Online",
    RT: "Rút tiền",
  };
  return codeMap[code] || code;
};

const CARD_FIELD_DEFAULTS = {
  cardName: "Thẻ tín dụng",
  description: "Thẻ tín dụng với nhiều ưu đãi hấp dẫn",
  gift: "Đang cập nhật",
  annualFee: "Đang cập nhật",
  annualFeeOffer: "Đang cập nhật",
  giftOffer: "Đang cập nhật",
  income: "Đang cập nhật",
  age: "Đang cập nhật",
  area: "Toàn quốc",
  annualFeeFree: "Đang cập nhật",
  interestRate: "Đang cập nhật",
  withdrawalFee: "Đang cập nhật",
  installmentFee: "Đang cập nhật",
  foreignTransactionFee: "Đang cập nhật",
  maxLimit: "Đang cập nhật",
  benefits: [],
  offerPolicyList: [],
  applyUrl: "",
};

const buildCardDetails = (card) => {
  const deeplink = card?.registerDeeplink || {};
  const benefitsRaw = parseBenefits(
    card?.registerDeeplink?.futuresCard ?? card?.futuresCard
  );
  const benefits = benefitsRaw.map((benefit) =>
    convertFuturesCardCode(benefit)
  );
  const minAge = deeplink.minAge;
  const maxAge = deeplink.maxAge;
  const age =
    minAge && maxAge
      ? `${minAge} - ${maxAge}`
      : minAge ?? maxAge ?? CARD_FIELD_DEFAULTS.age;

  return {
    cardName: card?.name ?? CARD_FIELD_DEFAULTS.cardName,
    description:
      deeplink.description ??
      card?.description ??
      card?.shortDescription ??
      CARD_FIELD_DEFAULTS.description,
    imageSrc: deeplink.imgProduct || FALLBACK_CARD_IMAGES[0],
    maxLimit: formatCurrencyVND(deeplink.limit) || CARD_FIELD_DEFAULTS.maxLimit,
    gift: formatCurrencyVND(deeplink.gift) ?? CARD_FIELD_DEFAULTS.gift,
    annualFee:
      formatCurrencyVND(deeplink.annualFee) ?? CARD_FIELD_DEFAULTS.annualFee,
    annualFeePromotion:
      formatCurrencyVND(deeplink.annualFeePromotion) ??
      CARD_FIELD_DEFAULTS.annualFeeOffer,
    giftOffer:
      deeplink?.cardGifts?.length > 0
        ? deeplink?.cardGifts?.join(", ")
        : CARD_FIELD_DEFAULTS.giftOffer,
    offerPolicyList:
      deeplink?.cardOffers?.length > 0 ? deeplink?.cardOffers : [],
    income: formatCurrencyVND(deeplink.incomeMin) ?? CARD_FIELD_DEFAULTS.income,
    annualFeeFree: deeplink.annualFeeFree ?? CARD_FIELD_DEFAULTS.annualFeeFree,
    interestRate: deeplink.interestRate ?? CARD_FIELD_DEFAULTS.interestRate,
    feeCash: deeplink.feeCash ?? CARD_FIELD_DEFAULTS.withdrawalFee,
    feeInstallment:
      deeplink.feeInstallment ?? CARD_FIELD_DEFAULTS.installmentFee,
    feeTrans: deeplink.feeTrans ?? CARD_FIELD_DEFAULTS.foreignTransactionFee,
    benefits,
    age,
    area: deeplink.screenCity ?? CARD_FIELD_DEFAULTS.area,
  };
};

const CardInfo = () => {
  const { cardId } = useParams();
  const [card, setCard] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [cardDetails, setCardDetails] = useState(() => buildCardDetails(null));
  const [applyUrl, setApplyUrl] = useState("");
  useEffect(() => {
    if (!cardId) {
      setIsLoading(false);
      return;
    }
    setIsLoading(true);
    getCardById(DEFAULT_HEADERS, cardId)
      .then((res) => {
        const responseData = res?.data ?? null;

        if (responseData) {
          setCard(responseData);
        } else {
          toast.error("Không tìm thấy thông tin thẻ");
        }
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.message ||
            "Không thể tải thông tin thẻ. Vui lòng thử lại sau."
        );
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [cardId]);

  useEffect(() => {
    const details = buildCardDetails(card);
    setCardDetails(details);
    setApplyUrl(details.applyUrl || "");

    const productLink = details.applyUrl || card?.registerDeeplink?.link;
    if (!cardId || !productLink) {
      return;
    }

    let isSubscribed = true;
    const fetchTrackingLink = async () => {
      try {
        const res = await getTrackingLink(DEFAULT_HEADERS, cardId);
        const data = res?.data ?? [];
        if (!Array.isArray(data) || data.length === 0) {
          return;
        }

        const matchedLink = data.find((item) => item.link === productLink);
        if (matchedLink?.linkAff && isSubscribed) {
          setApplyUrl(matchedLink.linkAff);
        }
      } catch (error) {
        console.error("Failed to fetch tracking link", error);
      }
    };

    fetchTrackingLink();

    return () => {
      isSubscribed = false;
    };
  }, [cardId, card]);

  const {
    cardName,
    description,
    imageSrc,
    maxLimit,
    gift,
    annualFee,
    annualFeePromotion,
    giftOffer,
    income,
    annualFeeFree,
    interestRate,
    feeCash,
    feeInstallment,
    feeTrans,
    benefits,
    offerPolicyList,
    age,
    area,
  } = cardDetails;

  if (isLoading) {
    return (
      <div className="card-info">
        <div
          className="container"
          style={{ padding: "50px", textAlign: "center" }}
        >
          <p>Đang tải thông tin thẻ...</p>
        </div>
      </div>
    );
  }

  if (!card) {
    return (
      <div className="card-info">
        <div
          className="container"
          style={{ padding: "50px", textAlign: "center" }}
        >
          <p>Không tìm thấy thông tin thẻ.</p>
          <Link to="/dich-vu/mo-the">
            <button className="btn-back">Quay lại</button>
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="card-info">
      <section className="card-info-section">
        <div className="card-info-content container">
          <div className="row">
            <div className="col-md-6 card-info-left">
              <div className="card-info-subtitle">
                <span className="subtitle-normal">Thẻ tín dụng</span>
                <br />
                <span className="subtitle-bold">{cardName}</span>
              </div>

              <div className="card-info-description">{description}</div>

              <div className="card-info-features row">
                {benefits.length > 0 ? (
                  benefits.map((benefit, index) => (
                    <div key={index} className="col-md-6 col-12">
                      <div className="mothe-feature-item d-flex align-items-center">
                        <div className="check-icon">
                          <img src={check} alt="check" className="check" />
                        </div>
                        <div>{benefit}</div>
                      </div>
                    </div>
                  ))
                ) : (
                  <>
                    <div className="col-md-6 col-12">
                      <div className="mothe-feature-item d-flex align-items-center">
                        <div className="check-icon">
                          <img src={check} alt="check" className="check" />
                        </div>
                        <div>Ưu đãi nổi bật</div>
                      </div>
                      <div className="mothe-feature-item d-flex align-items-center">
                        <div className="check-icon">
                          <img src={check} alt="check" className="check" />
                        </div>
                        <div>Hoàn tiền hấp dẫn</div>
                      </div>
                    </div>
                    <div className="col-md-6 col-12">
                      <div className="mothe-feature-item d-flex align-items-center">
                        <div className="check-icon">
                          <img src={check} alt="check" className="check" />
                        </div>
                        <div>Chi tiêu Online ưu đãi lớn</div>
                      </div>
                      <div className="mothe-feature-item d-flex align-items-center">
                        <div className="check-icon">
                          <img src={check} alt="check" className="check" />
                        </div>
                        <div>Trả góp linh hoạt</div>
                      </div>
                    </div>
                  </>
                )}
              </div>
            </div>
            <div className="col-md-6 card-info-right">
              <img
                src={imageSrc}
                alt="info-card-img"
                className="info-card-img"
              />
            </div>
          </div>
        </div>
      </section>

      <section className="card-content-section">
        <div className="container">
          <div className="come-back-card">
            <Link to="/dich-vu/mo-the">
              <button className="btn-back">Quay lại</button>
            </Link>
          </div>
          <div className="card-detail">
            <div className="row">
              <div className="col-sm-4 card-detail-left">
                <img src={imageSrc} alt="Card" className="img-card-detail" />
                <span className="tag-card">
                  <img src={star} alt="star" className="star" />
                  {card?.registerDeeplink?.tag}
                </span>
              </div>
              <div className="col-sm-8 card-detail-right">
                <div className="card-icons">
                  <div className="icon-item">
                    <img src={cardSecure} alt="secure" className="secure" />
                    <span>Bảo mật 3D Secure & PCI DSS</span>
                  </div>
                  <div className="icon-item">
                    <img
                      src={contactless}
                      alt="contactless"
                      className="contactless"
                    />
                    <span>Thanh toán không tiếp xúc</span>
                  </div>
                  <div className="icon-item">
                    <img src={visa} alt="visa" className="visa" />
                    <span>Được bảo chứng bởi Visa</span>
                  </div>
                </div>

                {/* Bảng thông tin */}
                <div className="card-info-box">
                  <div className="card-text-box">
                    <div>
                      <p>Hạn mức tối đa</p>
                      <h3>{maxLimit}</h3>
                    </div>
                    <div>
                      <p>Quà tặng</p>
                      <h3>{gift}</h3>
                    </div>
                    <div>
                      <p>Phí thường niên</p>
                      <h3>{annualFee}</h3>
                    </div>
                  </div>

                  <div className="card-divier"></div>

                  <div className="card-offer">
                    <span>Ưu đãi phí thường niên</span>
                    <strong>{annualFeePromotion}</strong>
                  </div>
                </div>

                <div className="card-buttons">
                  {applyUrl ? (
                    <button
                      className="btn-custom-card"
                      onClick={() => {
                        if (typeof window !== "undefined") {
                          window.open(
                            applyUrl,
                            "_blank",
                            "noopener,noreferrer"
                          );
                        }
                      }}
                    >
                      Mở thẻ ngay
                    </button>
                  ) : (
                    <button
                      className="btn-custom-card"
                      data-bs-target="#notificationModal"
                      data-bs-toggle="modal"
                    >
                      Mở thẻ ngay
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>

          <section className="card-stats">
            <div className="card-stats-container row d-flex justify-content-center">
              <div className="card-stats-item">
                <img
                  src={cardMoneyOnline}
                  alt="Khách hàng"
                  className="card-stats-icon"
                />
                <div className="card-stats-text">Ưu đãi lớn</div>
                <div className="card-stats-label">
                  Có ngay hạn mức chi tiêu ưu đãi cho các sàn TMĐT
                </div>
              </div>
              <div className="card-stats-item">
                <img src={cardApp} alt="Đối tác" className="card-stats-icon" />
                <div className="card-stats-text">Hoàn tiền </div>
                <div className="card-stats-label">
                  Hoàn tiền lên đến 10% / tháng cho nhiều ngành hàng phổ biến
                </div>
              </div>
              <div className="card-stats-item">
                <img
                  src={cardHandTouch}
                  alt="Sản phẩm"
                  className="card-stats-icon"
                />
                <div className="card-stats-text">Miễn phí thường niên </div>
                <div className="card-stats-label">
                  Miễn phí phát hành, hoàn phí thường niên khi chi tiêu đủ điều
                  kiện
                </div>
              </div>
              <div className="card-stats-item">
                <img
                  src={cardGroup}
                  alt="Kinh nghiệm"
                  className="card-stats-icon"
                />
                <div className="card-stats-text">Trả góp 0%</div>
                <div className="card-stats-label">
                  Chuyển đổi trả góp linh hoạt. <br />
                  Chủ động tài chính
                </div>
              </div>
            </div>
          </section>

          <div className="card-text-section">
            <h3 className="card-title">ƯU ĐÃI</h3>

            <div className="row card-row">
              <div className="col-md-3">
                <p className="title-label-color">Quà tặng mở thẻ</p>
              </div>
              <div className="col-md-9">
                <p className="text-card-bold">{giftOffer}</p>
              </div>
            </div>

            {offerPolicyList.length > 0 && (
              <div className="row card-row">
                <div className="col-md-3">
                  <p className="title-label-color">Chính sách ưu đãi</p>
                </div>
                <div className="col-md-9">
                  <ul className="text-card-ul">
                    {offerPolicyList.map((item, index) => (
                      <li key={index} className="text-card-li">
                        {item}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            )}
          </div>

          <div className="card-text-section mt-4">
            <h3 className="card-title">ĐIỀU KIỆN MỞ THẺ</h3>
            {income && income !== "Đang cập nhật" && (
              <div className="row card-row">
                <div className="col-md-3">
                  <p className="card-label">Thu nhập</p>
                </div>
                <div className="col-md-9">
                  <p className="card-value">{income}</p>
                </div>
              </div>
            )}

            {age && age !== "Đang cập nhật" && (
              <div className="row card-row">
                <div className="col-md-3">
                  <p className="card-label">Tuổi</p>
                </div>
                <div className="col-md-9">
                  <p className="card-value">{age}</p>
                </div>
              </div>
            )}

            {area && (
              <div className="row card-row">
                <div className="col-md-3">
                  <p className="card-label">Khu vực</p>
                </div>
                <div className="col-md-9">
                  <p className="card-value">{area}</p>
                </div>
              </div>
            )}
          </div>

          <div className="card-text-section mt-4">
            <h3 className="card-title">LÃI & PHÍ</h3>
            {annualFeeFree && annualFeeFree !== "Đang cập nhật" && (
              <div className="row card-row">
                <div className="col-md-3">
                  <p className="card-label">Miễn phí thường niên</p>
                </div>
                <div className="col-md-9">
                  <p className="card-value">{annualFeeFree}</p>
                </div>
              </div>
            )}

            {interestRate && interestRate !== "Đang cập nhật" && (
              <div className="row card-row">
                <div className="col-md-3">
                  <p className="card-label">Lãi suất</p>
                </div>
                <div className="col-md-9">
                  <p className="card-value">{interestRate}</p>
                </div>
              </div>
            )}

            {feeCash && feeCash !== "Đang cập nhật" && (
              <div className="row card-row">
                <div className="col-md-3">
                  <p className="card-label">Phí rút tiền mặt</p>
                </div>
                <div className="col-md-9">
                  <p className="card-value">{feeCash}</p>
                </div>
              </div>
            )}

            {feeInstallment && feeInstallment !== "Đang cập nhật" && (
              <div className="row card-row">
                <div className="col-md-3">
                  <p className="card-label">Phí chuyển đổi trả góp</p>
                </div>
                <div className="col-md-9">
                  <p className="card-value">{feeInstallment}</p>
                </div>
              </div>
            )}

            {feeTrans && feeTrans !== "Đang cập nhật" && (
              <div className="row card-row">
                <div className="col-md-3">
                  <p className="card-label">Phí giao dịch ngoại tệ</p>
                </div>
                <div className="col-md-9">
                  <p className="card-value">{feeTrans}</p>
                </div>
              </div>
            )}
          </div>
        </div>
      </section>

      <ExclusiveOffer currentId={cardId}/>
    </div>
  );
};

export default CardInfo;
